// 语言切换路径和语言的对应关系
const LanguageMap = {
  ch: 'zh',
  // : 'kr',
  en: 'en'
}

export default LanguageMap